import { render, staticRenderFns } from "./PageCourse.vue?vue&type=template&id=590616a4&scoped=true&lang=pug"
import script from "./PageCourse.vue?vue&type=script&lang=ts"
export * from "./PageCourse.vue?vue&type=script&lang=ts"
import style0 from "./PageCourse.vue?vue&type=style&index=0&id=590616a4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590616a4",
  null
  
)

export default component.exports